import React, { useEffect, useState } from "react"
import { Form, useNavigate } from "react-router-dom"
import { Container } from "reactstrap"
import Breadcrumbs from "components/Common/Breadcrumb"
import ConfigUrl, { axiosbaseurl } from "../../config"
import { notification } from "antd"
import { SiTicktick } from "react-icons/si"
import { IoMdWarning } from "react-icons/io"
import Loader from "pages/Loader"
import { usePermissionData } from "AppContext"
import PermittedComponent from "PermittedComponent"
import { FaChevronLeft, FaChevronRight, FaSave } from "react-icons/fa"

const AddTestimonial = () => {

   document.title = "Testimonials | Return First Investments"

  const { checkAccess } = usePermissionData()

  const navigate = useNavigate()

  const [Loading, setLoading] = useState(false)

  // State for storing user photo and its preview URL
  const [UserPhoto, setUserPhoto] = useState(null)
  const [UserPhotoPreview, setUserPhotoPreview] = useState(null)

  // Handle image change
  const handleImageChange = e => {
    const file = e.target.files[0]
    if (file) {
      setUserPhoto(file)
      setUserPhotoPreview(URL.createObjectURL(file)) // Generate preview URL
    }
  }

  const [user, setUser] = useState({
    UserName: "",
    date : "",
    messgae : ""
  })

  // Error state for validation
  const [errors, setErrors] = useState({})

  // Handle input change
  const handleChange = e => {
    const { name, value } = e.target
    setUser(prev => ({ ...prev, [name]: value }))
  }

  // Validation function
  const validate = () => {
    let tempErrors = {}
    if (!user.UserName.trim()) tempErrors.UserName = "User Name is required"
    // if (!user.clientId.trim()) tempErrors.clientId = "Client ID is required";
    if(!user?.date) tempErrors.date = "Testimonial date is required"
    if(!user?.messgae) tempErrors.message = "Message is required"

    setErrors(tempErrors)
    return Object.keys(tempErrors).length === 0
  }

  // Handle form submission
  const handleSubmit = async () => {
    if (validate()) {
      try {
        setLoading(true)

        const Formdata = new FormData()
        Formdata.append("image", UserPhoto)
        Formdata.append("postedBy", user?.UserName)
        Formdata.append("postedAt",user?.date)
        Formdata.append("description",user?.messgae)

        const response = await axiosbaseurl.post(
          `testimonials`,
          Formdata
        )

        if (response?.data?.success) {
          setLoading(false)
          notification.open({
            message: (
              <div className="d-flex align-items-center">
                <div className="pr-20">
                  <SiTicktick className="text-success fs-4 me-2" />
                </div>
                <div className="succes-message">
                  Testimonial Created Successfully.
                </div>
              </div>
            ),
            placement: "topRight",
          })

          setTimeout(() => {
            navigate(`${ConfigUrl.appurl}testimonials`)
          }, 1000)
        } else {
          setLoading(false)
          notification.open({
            message: (
              <div className="d-flex">
                <div className="pr-10">
                  <IoMdWarning className="text-danger" size={22} />
                </div>
                <div>Opps! Something went wrong.</div>
              </div>
            ),
          })
        }
      } catch (e) {
        setLoading(false)
        notification.open({
          message: (
            <div className="d-flex">
              <div className="pr-10">
                <IoMdWarning className="text-danger" size={22} />
              </div>
              <div>Opps! Something went wrong.</div>
            </div>
          ),
          description: e?.response?.data?.message,
        })
      }
    }
  }

  return (
    <React.Fragment>
      {Loading && <Loader />}
      <PermittedComponent isAccess={checkAccess(8, 2)}>
        <div className="page-content">
          <Container fluid>
            <Breadcrumbs title="Testimonials" breadcrumbItem="Add Testimonial" />

            <div className="card p-3">
              <div className="text-end">
                <button
                  className="btn edit-Button bg-success text-white me-3 rounded-5"
                  onClick={handleSubmit}
                >
                  <FaSave className="me-2" />
                  Submit
                </button>
                <button
                  className="btn delete-Button rounded-5"
                  onClick={() => navigate(-1)}
                >
                  <FaChevronLeft className="me-2" />
                  Back
                </button>
              </div>
              <div className="Line" />

              <div className="row my-3">
                <div className="form-group col-xl-7 col-12">
                  <label>
                    User Photo
                  </label>
                  <input
                    type="file"
                    className="form-control"
                    placeholder="Enter Full name"
                    name="Profile Image"
                    accept="image/*"
                    onChange={handleImageChange}
                  />
                </div>
                {UserPhotoPreview && (
                  <div className="col-xl-1">
                    <img
                      className="Profile-img"
                      src={UserPhotoPreview}
                      alt="User Preview"
                    />
                  </div>
                )}

                {/* User Name */}
                <div className="form-group col-xl-6 col-12 mt-3">
                  <label>
                    Full Name <span className="text-danger">*</span>
                  </label>
                  <input
                    type="text"
                    className="form-control"
                    placeholder="Enter Full name"
                    name="UserName"
                    value={user.UserName}
                    onChange={handleChange}
                  />
                  {errors.UserName && (
                    <span className="text-danger">{errors.UserName}</span>
                  )}
                </div>

                <div className="form-group col-xl-6 col-12 mt-3">
                  <label>Testimonial Date <span className="text-danger">*</span></label>
                  <input
                    type="date"
                    className="form-control"
                    placeholder="Enter Full name"
                    name="date"
                    value={user.date}
                    onChange={handleChange}
                  />
                  {errors.date && <span className="text-danger">{errors.date}</span>}
                </div>

                <div className="form-group col-12 mt-3">
                  <label>Message <span className="text-danger">*</span></label>
                  <textarea
                    type="text"
                    className="form-control"
                    placeholder="Enter User Message"
                    name="messgae"
                    value={user.messgae}
                    onChange={handleChange}
                  />
                  {errors.message && <span className="text-danger">{errors.message}</span>}
                </div>

              </div>
            </div>
          </Container>
        </div>
      </PermittedComponent>
    </React.Fragment>
  )
}

export default AddTestimonial
